export function formatTraceStack(trace: string) {
  const shortTrace = trace.split('\n').slice(0, 10).join('\n');
  return shortTrace;
}
